/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 数据验证
 */

interface Rule {
  noName?: boolean;
  check: (value: any) => boolean;
  message: string;
}

export interface ValidateResult {
  /**
   * 错误消息
   */
  message: string;
  /**
   * 是否验证通过
   */
  pass: boolean;
}

export const rules = {
  /**
   * 是否为空
   */
  empty: {
    check: (value: any) =>
      !(
        value === null ||
        value === undefined ||
        value === '' ||
        (Array.isArray(value) && value.length === 0)
      ),
    message: '不能为空',
  },

  /**
   * 手机号码验证
   */
  cellphone: {
    noName: true,
    check: (value: any) => (value ? /^1\d{10}$/.test(value) : true),
    message: '手机号码格式不正确',
  },

  /**
   * 最小长度
   */
  minLength: (minLength: number) => ({
    check: (value: any) => (value.length ? value.length >= minLength : false),
    message: `最小长度不能小于${minLength}`,
  }),

  /**
   * 最大值
   */
  max: (max: number) => ({
    check: (value: number) => {
      if (!value) {
        return true;
      }

      if (Number.isNaN(Number(value))) {
        console.warn(`${value}不是有效的数字`);

        return true;
      }

      return value <= max;
    },
    message: `不能大于${max}`,
  }),

  /**
   * 最小值
   */
  min: (min: number) => ({
    check: (value: number) => {
      if (!value) {
        return true;
      }

      if (Number.isNaN(Number(value))) {
        console.warn(`${value}不是有效的数字`);

        return true;
      }

      return value >= min;
    },
    message: `不能小于${min}`,
  }),

  /**
   * 身份证
   */
  idCard: {
    noName: true,
    check: (value: string) => {
      const idreg =
        /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;

      return value ? idreg.test(value) : true;
    },
    message: `身份证格式不正确`,
  },
  /**
   * 邮箱
   */
  email: {
    noName: true,
    check: (value: string) => {
      const reg = new RegExp(
        '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
      );

      return value ? reg.test(value) : true;
    },
    message: `邮箱格式不正确`,
  },
};

/**
 * 验证一条规则
 */
export const validate = (
  name: string,
  value: any,
  rule: Rule,
  message?: string
): ValidateResult => {
  if (rule.check(value)) {
    return {
      pass: true,
      message: '',
    };
  }

  return {
    pass: false,
    message: message || `${rule.noName ? '' : name}${rule.message}`,
  };
};

/**
 * 验证多条规则
 */
export const validateMulti = (
  name: string,
  value: any,
  _rules: Rule[],
  message?: string[]
): ValidateResult => {
  let result = { pass: true, message: '' };

  _rules.some((rule, index) => {
    const resultItem = validate(
      name,
      value,
      rule,
      message ? message[index] || '' : ''
    );

    if (!resultItem.pass) {
      result = resultItem;

      return true;
    }

    return false;
  });

  return result;
};

/**
 * 验证数据对象
 */
export const validateObject = <
  T extends Record<string, any>,
  Keys extends keyof T
>(
  value: T,
  data: {
    [key in Keys]?: {
      name?: string;
      rules: Rule[];
      message?: string[];
    };
  }
): ValidateResult => {
  let result = {
    pass: true,
    message: '',
  };

  Object.keys(data).some(key => {
    const resultMulti = validateMulti(
      // @ts-ignore
      data[key].name || key,
      // @ts-ignore
      value[key],
      // @ts-ignore
      data[key].rules,
      // @ts-ignore
      data[key].message
    );

    if (!resultMulti.pass) {
      result = resultMulti;

      return true;
    }

    return false;
  });

  return result;
};
